if (('IntersectionObserver' in window) ||
  ('IntersectionObserverEntry' in window) ||
  ('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
  initObserver()
}

function initObserver() {
  const sections = document.querySelectorAll('[data-motion]');
  setClasses(sections);

  const options = {
    root: document.element,
    rootMargin: '0px',
    threshold: window.innerWidth <= window.innerHeight ? .1 : .25,
  }

  const observer = new IntersectionObserver(update, options);

  function update(entries) {
    Array.prototype.forEach.call(entries, (entry) => {
      const ratio = entry.intersectionRatio;
      if (ratio > 0.1) {
        entry.target.classList.add('motion--visible');
        observer.unobserve(entry.target);
      };
    })
  }

  Array.prototype.forEach.call(sections, (section) => {
    observer.observe(section)
  })
}

function setClasses(sections) {
  Array.prototype.forEach.call(sections, (section) => {
    section.classList.add('motion');
  })
}
